/**
 * StatBar Component
 * Animated progress bar for vendor metrics
 * @component
 */

import React, { useEffect, useRef, useState } from 'react';
import { StatBarProps } from '../types';

export const StatBar: React.FC<StatBarProps> = ({ label, score, colorClass }) => {
  const [width, setWidth] = useState(0);
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Trigger animation after component mounts
    const timer = setTimeout(() => {
      setWidth(score * 10);
    }, 100);

    return () => clearTimeout(timer);
  }, [score]);

  return (
    <div className="mb-3">
      <div className="flex justify-between mb-1 text-sm">
        <span className="font-medium text-gray-300">{label}</span>
        <span className="font-semibold text-white">{score.toFixed(1)}/10</span>
      </div>
      <div className="w-full bg-gray-700 rounded-full h-2.5">
        <div
          ref={barRef}
          className={`stat-bar-fill ${colorClass} h-2.5 rounded-full transition-all duration-700 ease-out`}
          style={{ width: `${width}%` }}
          role="progressbar"
          aria-valuenow={score}
          aria-valuemin={0}
          aria-valuemax={10}
          aria-label={`${label}: ${score} out of 10`}
        />
      </div>
    </div>
  );
};
